import { APICore } from "helpers/api/apiCore";

const api = new APICore();

/**
 * POST to a fully-built unmask URL with { fieldName }.
 * Module api.ts functions should build the URL; UI should not.
 */
export const unmaskPiiFieldByUrl = async (unmaskUrl: string, fieldName: string): Promise<string> => {
  const response = await api.create(unmaskUrl, { fieldName });
  return response?.data?.data?.value ?? response?.data?.value ?? "";
};
